interface DriverTableProps {
  driversWithColors: Array<{
    name: string;
    color: string;
  }>;
}

const DriverTable = ({ driversWithColors }: DriverTableProps) => {
  return (
    <div className="leaflet-bottom leaflet-left">
      <div className="leaflet-control leaflet-bar bg-white text-gray-900 p-2 rounded shadow-md space-y-2">
        {driversWithColors.map((driver, index) => {
          const color = driver.color;

          return (
            <div key={index} className="flex items-center space-x-2">
              <span
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: color }}
              ></span>
              <span className="text-sm">{driver.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DriverTable;
